import PropTypes from 'prop-types'
import React from 'react'

import { PromotionCardVLP, VehicleCardBravo } from '@sm360/components'
import VehicleCardAlpha from '../../components/vehicle-cards/VehicleCardAlpha'

import { VehicleCardContext } from '../../configs/vehicle-card-view/state.manager'
import { saveQuote, getCalculatorApiUrl } from '../../apis/showroom360/showroom360.service'

const VehicleCardView = ({ packageVersion, isCalculatorModalOpen, promoCards, vehicle, hasVehicles }) => {
    const {
        state: { vehicleCtas, dealerInfos = {}, XMSConfig, isHumberview },
    } = React.useContext(VehicleCardContext)

    const { orgUnitMakes = [] } = dealerInfos

    // used for sendind ford-specific parameters on the baseball card CTA
    const isFord = orgUnitMakes.length === 1 && orgUnitMakes.includes('ford')

    const { configuration } = XMSConfig || {}

    const version = packageVersion === 'premium' ? 'bravo' : 'alpha'
    const isPromoTile = !vehicle?.vehicleId && promoCards?.length > 0

    return (
        <>
            {version === 'alpha' &&
                (isPromoTile && !isHumberview ? (
                    <PromotionCardVLP
                        promotion={vehicle}
                        layout={configuration?.promotionsLayoutType}
                        sendUrlParams={isFord}
                        dealerInfos={dealerInfos}
                        hasVehicles={hasVehicles}
                    />
                ) : (
                    <VehicleCardAlpha />
                ))}

            {version === 'bravo' &&
                (isPromoTile ? (
                    <PromotionCardVLP
                        promotion={vehicle}
                        layout={configuration?.promotionsLayoutType}
                        sendUrlParams={isFord}
                        dealerInfos={dealerInfos}
                    />
                ) : (
                    <VehicleCardBravo
                        isCalculatorModalOpen={isCalculatorModalOpen}
                        vehicle={vehicle}
                        vehicleCtas={vehicleCtas}
                        dealerInfos={dealerInfos}
                        XMSConfig={XMSConfig}
                        saveQuote={saveQuote}
                        getCalculatorApiUrl={getCalculatorApiUrl}
                    />
                ))}
        </>
    )
}

VehicleCardView.propTypes = {
    /** Extra Classes */
    extraClasses: PropTypes.string,
    packageVersion: PropTypes.string,
    /** Flag for Calculator Modal */
    isCalculatorModalOpen: PropTypes.bool,
    /** Has vehicles */
    hasVehicles: PropTypes.bool,
}

VehicleCardView.defaultProps = {
    extraClasses: '',
    packageVersion: '',
}

export default VehicleCardView
